import styled from '@emotion/styled';

export const ArticleContainer = styled.article`
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
`;

export const Main = styled.main`
  display: flex;
  justify-content: center;
  text-align: center;
  padding: 1rem;
  width: 100%;
  height: 100%;
`;
